(function () {
    'use strict';

    angular
        .module('uwAgenda.settings.administration')
        .controller('ProtocolCategoryTableController', ProtocolCategoryTableControllerFn);

    /* controller for protocol categories table */
    ProtocolCategoryTableControllerFn.$inject = ['ItemTableService', '$state'];

    function ProtocolCategoryTableControllerFn(ItemTableService, $state) {
        var vm = this;
        // the service -> here the ItemTableService
        vm.overview = null;

        // start
        activate();

        // add new row to table
        vm.add = function () {
            ItemTableService.add();
        };

        // show all
        vm.showAll = function () {
            $state.go($state.current.name, { all: vm.overview.data.showAll }, { reload: $state.current.name });
        };
        
        /* activation work */
        function activate() {            
            //service
            vm.overview = ItemTableService;
            vm.overview.init(ItemTableService.items, ItemTableService.languages, ItemTableService.prototype, ItemTableService.requiredFields, false);
        } // activate
    }
})();
